<div id="warningDialog" class="session-confirm">
  <header>
    @if (!isError) {
      <h1 mat-dialog-title class="confirm-close">
        <div class="icon-background amber">
          <img alt="exclamation sign" class="icon" src="assets/images/white-exclamation.svg">
        </div>
        {{'Session.AreYouThere' | translate}}
      </h1>
    }
    @if (isError) {
      <h1 mat-dialog-title class="confirm-close">
        <div class="icon-background red">
          <img alt="exclamation sign" class="icon" src="assets/images/white-exclamation.svg">
        </div>
        {{'Session.SessionExpired' | translate}}
      </h1>
    }
    <hr/>
  </header>
  <mat-dialog-content>
    @if (!isError) {
      <div id="session-msg" class="prewrap-text"
      [innerHTML]="('Session.YourSessionHasBeenInactiveFor' | translate) + inactive + ('Session.ClickExtendSessionInTheNext' | translate) + mins + ('Session.MinutesToRemainLoggedInToAvoidLosingAnyUnsavedData' | translate)"></div>
    }
    @if (isError) {
      <div id="session-end-msg" class="prewrap-text"
      [innerHTML]="('Session.YourSessionHasExpiredDueToInactivityFor' | translate) + inactive + ('Session.Minutes' | translate)"></div>
    }
    <ng-container>
      <button id="dialog-cancel" class="btn ontario-button--primary ontario-button confirm-button" (click)="close()">
        {{(!isError ? 'Session.ExtendSession' : 'Session.Login') | translate}}
      </button>
    </ng-container>
  </mat-dialog-content>
</div>
